
import React, { useState } from "react";
//--- utils ---
import dayjs from "dayjs";
//--- components ---
import WaterCard from "./water-card";
import DashboardChart from "./chart";
import { UrlCollection } from "../../common/url-collection";
import CameraComponent from "./camera";
import { WaterMonitoring } from "../../models/types/waterMonitoring";
import { listDeviceStatus, listStatus } from "../../utils/helper";
import { useResponsive } from "../../hooks/mediaQuery";
import { useTranslation } from "react-i18next";

const DashboardComponent = ({ waterMonitoringData, deviceStatuses }: { waterMonitoringData: WaterMonitoring, deviceStatuses: any[] }) => {
    const [currentTab, setCurrentTab] = useState<'camera' | 'chart' | 'map' | ''>('camera');
    const { isXs } = useResponsive();
    const { t } = useTranslation();

    const listTabs = [
        {
            label: t('homePage.camera'),
            value: 'camera'
        },
        {
            label: t('homePage.chart'),
            value: 'chart'
        },
        {
            label: t('homePage.map'),
            value: 'map'
        }
    ]

    const renderContent = () => {
        switch (currentTab) {
            case 'camera':
                return <CameraComponent stationId={waterMonitoringData.stationId} />;
            case 'chart':
                return <DashboardChart stationId={waterMonitoringData.stationId} />;
            case 'map':
                window.open(UrlCollection.Map + `?stationId=${waterMonitoringData.stationId}`, '_blank');
                return null;
            default:
                return null;
        }
    }
    return (
        <div className="dashboard_item bg-white md:p-4 p-2">
            {/* Legend */}
            <div className="flex flex-wrap justify-between gap-2 mb-2">
                <div className="annotate flex gap-2">
                    {listDeviceStatus.map((status) => (
                        <div key={status.value} className="flex items-center gap-1">
                            <div className={`dot ${status.color}`}></div>
                            <span className={`${isXs ? 'text-xs' : 'text-sm'} text ${status.color}`}>{t(`${status.label}`)}</span>
                        </div>
                    ))}
                </div>
                <div className="annotate flex gap-1">
                    {listStatus.map((frame) => (
                        <div key={frame.value} className={`frame ${isXs ? 'flex-1' : ''} ${frame.color}`}>
                            <p className={`${isXs ? 'text-xs' : 'text-sm'}`}>{t(`${frame.label}`)}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <div>
                    <h2 className="font-bold text-lg">{waterMonitoringData?.stationName}</h2>
                    <p className="text-gray-600 text-sm">
                        {t('homePage.updateTime')} {dayjs(waterMonitoringData?.waterMonitoringTime).format("DD/MM/YYYY HH:mm:ss")}
                    </p>
                </div>
                <div>
                    {listTabs.map((tab: any) => (
                        <button
                            key={tab.value}
                            className={`px-4 py-2 rounded-md border border-gray-300 hover:bg-blue-400 hover:text-white transition-colors ${currentTab === tab.value ? 'bg-blue-500 text-white' : ''}`}
                            onClick={() => setCurrentTab(tab.value)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
            {/* Cards Grid */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:mb-6 mb-4">
                {waterMonitoringData.data.map((param: any, idx: number) => {
                    const color = listDeviceStatus.find((item: any) => item.value === param.deviceStatus)?.color || "gray";
                    const border = listStatus.find((item: any) => item.value === param.status)?.color || "gray";
                    const isWarning = param.deviceStatus === 2;
                    // notify("Cảnh báo", "Thiết bị vượt ngưỡng", "danger", 100000, "/assets/audio/beep-warning.mp3", "bottom-right");
                    return (
                        <WaterCard key={idx} param={param} color={color} border={border} isWarning={isWarning} />
                    )
                })}
            </div>
            <hr className="md:mb-6 mb-4" />
            {renderContent()}
        </div>

    );
}

export default DashboardComponent;